import { useContext, useEffect } from "react";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { Button } from "@ui/components/forms/button/Button";
import { Controller, MapState } from "./controller";
import { ECCOIcon } from "@ui/components/media-and-icons/ecco-icon/ECCOIcon";
import { useApi } from "@lib/helpers/useApi";
import { QueryKeys } from "@lib/enums/QueryKeys";
import { getParcelShopsByCoordinates } from "./utils/parcelShops";
import { ShippingMethodTypes } from "@components/commerce/checkout/types";
import { activeSiteConfig } from "@config/site/site-config";

export const Capture = ({ shippingMethodKey }: { shippingMethodKey?: ShippingMethodTypes }) => {
    const { get: getMicrocopy } = useMicrocopy();
    const {
        setStoreData,
        setMapState,
        clientLocation,
        setFilterDistance,
        filterDistance,
        setCurrentLocation,
    } = useContext(Controller);

    const handleCapture = () => {
        setCurrentLocation();
        if (filterDistance) setFilterDistance(null);
    };

    const { searchMethod } = activeSiteConfig?.checkout?.parcelShops || {};
    const { data } = useApi.useAsync(
        [QueryKeys.getParcelShops, clientLocation?.lat, clientLocation?.lng],
        () =>
            getParcelShopsByCoordinates({
                latitude: clientLocation?.lat,
                longitude: clientLocation?.lng,
            }),
        {
            enabled:
                searchMethod === "latlng" &&
                !!clientLocation &&
                shippingMethodKey === ShippingMethodTypes.PARCEL_SHOP,
        }
    );

    useEffect(() => {
        if (data) {
            setStoreData(data);
            setFilterDistance(null);
            setMapState(MapState.Ready);
        }
    }, [clientLocation, data]);

    return (
        <Button
            h="initial"
            variant="link"
            textDecoration="none"
            fontWeight="bold"
            justifyContent="flex-start"
            onClick={handleCapture}
            leftIcon={<ECCOIcon name="store-locator" />}
        >
            <span>{getMicrocopy("page", "storeLocator.captureLocation")}</span>
        </Button>
    );
};
